import { render, staticRenderFns } from "./TrashButton.vue?vue&type=template&id=6e77c1af"
import script from "./TrashButton.vue?vue&type=script&lang=js"
export * from "./TrashButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports